import React, { Component } from "react";
import * as Constants from "../../../common/Global/constants";
import { isEmptyVariable,getLocalStorageVariables,getStringWithSpaceAfterComma,isJsonString, hasFeatureAccess, handleTokenExpiry } from "../../../common/Global/commonFunctions";
import moment from "moment";
import ReportDetails from "./reportDetails";
import { AssigmentDetailsIconLayout } from '../../../common/Global/globalStyles.style';
import InfoCardComponent from "../../Execute/infoCard/infoCardComponent";
import {getAllReportTasks,} from '../../Execute/Tasks/execTaskUtilFunctions';
import AlertDialog from "../../../common/AlertDialog";
let userDetails = getLocalStorageVariables();
const projectAuditType = "Project";
const employeeAuditType = "Employee";

class AssignmentHeading extends Component {
    constructor(props) {
        super(props);
        this.state = {
            assignmentDetails:{},
            showDetailsDialog: false,
			selectedItem: "",
            showInfoCard:false,
            totalTaksCount:0,
            isSampleChecked:false
        }
        userDetails = getLocalStorageVariables();
    }

    handleDetailsDialogClose = () => {
		this.setState({
			showDetailsDialog: false,
			selectedItem: "",
		});
	};

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
        if(this.state.responseCode === Constants.CODE_ASSIGNMENT_ACCESS_ERROR ||
            this.state.responseCode === Constants.CODE_ASSIGNMENT_SPECIFIC_ACCESS_ERROR){
			this.props.history.push(Constants.URL_ONGOING_REPORTS);
		}
    }

	handleDetailsDialogShow = (item, unitList) => {
		this.setState({
			showDetailsDialog: true,
			selectedItem: item,
            unitList: unitList
		});
	};
    handleGetAssignmentDetails = () => {
		// this.setState({
		// 	showLoader: true,
		// });

        let url = "";
        let postParam = {
			email: userDetails.email,
			accessToken: userDetails.accessToken,
			assignmentId: this.props.assignmentId,
		}
        if(this.props.isDraftOnward === true){
            url = Constants.GetDraftAssignmentsDetails;
            postParam.forDraft = true;
        }else{
            url = Constants.GetAssignmentsDetails;
        }
        
        
		fetch(url, {
			method: "POST",
			mode: "cors",
			body: new URLSearchParams(postParam),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let assignmentDetails = {};
                let unitList = [];
                if(handleTokenExpiry(data.responseCode)) return;
				else if (data.responseCode === Constants.CODE_SUCCESS) {
                    if(this.props.isDraftOnward === true){
                        assignmentDetails = data.data.result;
                    }
                    else{
                        assignmentDetails = data.data.assignmentDetails;
                    }
                    if(assignmentDetails.auditType === projectAuditType){
                        unitList = data.data.projectUnitList;
                    }else if(assignmentDetails.auditType === employeeAuditType){
                        unitList = data.data.defaultEmployeeUnitList;
                    }
				} else {
				}
                this.setState({
                    assignmentDetails: assignmentDetails,
                    unitList:unitList
                },()=>{
                    this.handleDetailsDialogShow(this.state.assignmentDetails, this.state.unitList);
                });
			});
	};


    handleGetInfoCardDetials =() =>{
        let getTaskListUrl = Constants.GetReportsTasksAll;
        let getAssignmentDetailsUrl = Constants.GetAssignmentsDetails;
        let postParam = {
            email: userDetails.email,
            accessToken: userDetails.accessToken,
            assignmentId: this.props.assignmentId,
        }
        Promise.all([
			fetch(getTaskListUrl, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams(postParam),
			}),
			fetch(getAssignmentDetailsUrl, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams(postParam),
			}),
		])
			.then(([taskRes, assignmentRes]) => {
				return Promise.all([taskRes.json(),assignmentRes.json()]);
			})
			.then(([taskRes,assignmentRes]) => {
				let allDatalistTemp = [];
				let myDatalistTemp = [];
				let assignmentArea = "";
				
                //Since we need assignment area lets check this first
                let selectedTaskTemplateFields = [];
                let execTaskTemplateFields = [];
                let taskTemplateValuesMap = {};
                let executionTemplateValuesMap = {};
                let executionTemplateFixedFields = {};
                let assignmentRiskMatrix = [];
                let valueAdditions = [];
                
                if(handleTokenExpiry(assignmentRes.responseCode)) return;
                else if (assignmentRes.responseCode === Constants.CODE_SUCCESS) {
                        assignmentArea = assignmentRes.data.assignmentDetails.assignmentArea;

                    //TASK TEMPLATE RELATED STUFFS
                    taskTemplateValuesMap = assignmentRes.data.taskTemplateValuesMap;
                    let selectedTaskTemplateFieldsStr = assignmentRes.data.executionTemplateFields?.taskTemplateFields;//Template field IDs	
                    if(!isEmptyVariable(selectedTaskTemplateFieldsStr) && isJsonString(selectedTaskTemplateFieldsStr)){
                        selectedTaskTemplateFields = JSON.parse(selectedTaskTemplateFieldsStr);
                    }
                    
                    //EXEC TASK RELATED STUFFS
                    executionTemplateValuesMap = assignmentRes.data.executionTemplateValuesMap;
                    let execTaskTemplateFieldsStr = assignmentRes.data.executionTemplateFields?.templateFields;
                    if(!isEmptyVariable(execTaskTemplateFieldsStr) && isJsonString(execTaskTemplateFieldsStr)){
                        execTaskTemplateFields = JSON.parse(execTaskTemplateFieldsStr);
                    }

                    //EXEC TASK FIXED FIELDS
                    let fixedTemplateFieldsStr = assignmentRes.data.executionTemplateFields?.fixedTemplateFields;
                    if(!isEmptyVariable(fixedTemplateFieldsStr) && isJsonString(fixedTemplateFieldsStr)){
                        executionTemplateFixedFields = JSON.parse(fixedTemplateFieldsStr);
                    }

                    assignmentRiskMatrix = assignmentRes.data.riskLevels ?? [];
                    valueAdditions = assignmentRes.data.valueAdditions;

				} else {
				}

                let maxRank = 0;
                let temptotalTaksCount=0;
             
                if(handleTokenExpiry(taskRes.responseCode)) return;
				else if (taskRes.responseCode === Constants.CODE_SUCCESS) {
					allDatalistTemp = taskRes.data.assignedTasks;
					let allDataList = JSON.parse(JSON.stringify(allDatalistTemp))
					myDatalistTemp = getAllReportTasks(allDataList,assignmentArea,maxRank);

                     Object.values(myDatalistTemp).map((item)=>{
                        temptotalTaksCount+= Object.values(item.taskList).length
                    })
				} else if (taskRes.responseCode === Constants.CODE_ASSIGNMENT_ACCESS_ERROR) {
                    this.setState({
                        showAlertDialogInfo: true,
                        alertDialogMessageInfo: taskRes.responseMessage,
                        responseCode: taskRes.responseCode
                    })
                } 
                
				this.setState({
					datalist: myDatalistTemp,
                    selectedTaskTemplateFields:selectedTaskTemplateFields,
                    taskTemplateValuesMap:taskTemplateValuesMap,
                    execTaskTemplateFields:execTaskTemplateFields,
                    executionTemplateValuesMap:executionTemplateValuesMap,
                    executionTemplateFixedFields:executionTemplateFixedFields,
                    showInfoCard:true,
                    totalTaksCount:temptotalTaksCount,
                    assignmentArea: assignmentArea
				});
			});
            
    }

    closeInfoCard = () =>{
        this.setState({
            showInfoCard:false
        })
    }
    
    render(){
        return (
            <div className="assignment-heading" style={{marginTop:10}}>
                {
                    this.props.company?.companyType === Constants.USER_ENGAGEMENT_TYPE_SELF &&
                    !isEmptyVariable(this.props.assignmentDetails.unitNameCityList) &&
                    <p className="m-b-0 font-bold" style={{marginRight:20}}>
                        {/* {truncateString(getStringWithSpaceAfterComma(item.unitNameCityList),Constants.OTHERMASTERS_STRING_LENGTH)} */}
                        {getStringWithSpaceAfterComma(this.props.assignmentDetails.unitNameCityList)}
                    </p>
                }
                {
                    this.props.company?.companyType !== Constants.USER_ENGAGEMENT_TYPE_SELF &&
                    !isEmptyVariable(this.props.assignmentDetails.companyName) &&
                    <p className="m-b-0 font-bold" style={{marginRight:20}}>
                        {this.props.assignmentDetails.companyName} 
                    </p>
                }
                {!isEmptyVariable(this.props.assignmentDetails.assignmentTypeName) &&
                    <p className="m-b-0 font-bold" style={{marginRight:20}}>
                        {this.props.assignmentDetails.assignmentTypeShortName} 
                    </p>
                }
                {/* {!isEmptyVariable(this.props.assignmentDetails.assignmentArea) &&
                    <p className="m-b-0 font-bold" style={{marginRight:20}}>
                        {props.assignmentDetails.assignmentArea} 
                    </p>
                } */}
                {!isEmptyVariable(this.props.assignmentDetails.endDate) &&
                    <p className="m-b-0 font-bold" style={{marginRight:20}}>
                        End Date: {moment(this.props.assignmentDetails.endDate).format("DD/MM/YYYY")} 
                    </p>
                }
                {this.props.isSampleChecked &&!isEmptyVariable(this.props.assignmentDetails.periodToDate) && !isEmptyVariable(this.props.assignmentDetails.periodFromDate) &&
                    <p className="m-b-0 font-bold" style={{marginRight:20}}>
                        {"Assignment Review Period: "+moment(this.props.assignmentDetails.periodFromDate).format("DD/MM/YYYY")} - {moment(this.props.assignmentDetails.periodToDate).format("DD/MM/YYYY")}
                    </p>
                }
                <AssigmentDetailsIconLayout themeSettings={this.props.themeSettings}>
                    {hasFeatureAccess(Constants.FEATURE_ON_EXECUTE_TASK_INFO_CARD) &&
                        <span class="material-icons" onClick={this.handleGetInfoCardDetials}>analytics</span>
                    }
                    <div className="tool" data-title="Assignment Info">
                        <span className="material-icons" onClick={this.handleGetAssignmentDetails}>info</span>
                    </div>
                </AssigmentDetailsIconLayout>

                <ReportDetails
                    showDetailsDialog={this.state.showDetailsDialog}
                    handleDetailsDialogClose={this.handleDetailsDialogClose}
                    selectedItem={this.state.selectedItem}
                    unitList={this.state.unitList}
                    themeSettings={this.props.themeSettings}
                    company={this.props.company}
                    isDraftOnward={this.props.isDraftOnward}
                    isSampleChecked={this.props.isSampleChecked}
                    allSettings={this.props.allSettings}
                />
               
                {
                 this.state.showInfoCard&&   
                <InfoCardComponent 
                execTaskTemplateFields = {this.state.execTaskTemplateFields}
                taskTemplateFields ={this.state.selectedTaskTemplateFields}
                datalist = {this.state.datalist}
                showUploadAnnexureDialog ={ this.state.showInfoCard}
                themeSettings={this.props.themeSettings}
                executionTemplateValuesMap ={this.state.executionTemplateValuesMap}
                handleSelectUploadAnnexureDialogClose={this.closeInfoCard}
                totalTaskCount={this.state.totalTaksCount}
                taskTemplateValuesMap ={this.state.taskTemplateValuesMap}
                assignmentArea = {this.props.assignmentDetails.assignmentArea}
                />}
                <AlertDialog
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type={Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                    themeSettings={this.props.themeSettings}
                />
            </div>
        );
    }

}
export default AssignmentHeading;

